// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class EndGameAction implements flatbuffers.IUnpackableObject<EndGameActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EndGameAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEndGameAction(bb:flatbuffers.ByteBuffer, obj?:EndGameAction):EndGameAction {
  return (obj || new EndGameAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEndGameAction(bb:flatbuffers.ByteBuffer, obj?:EndGameAction):EndGameAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EndGameAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GameEndGame;
}

static startEndGameAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GameEndGame);
}

static endEndGameAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEndGameAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  EndGameAction.startEndGameAction(builder);
  EndGameAction.addType(builder, type);
  return EndGameAction.endEndGameAction(builder);
}

unpack(): EndGameActionT {
  return new EndGameActionT(
    this.type()
  );
}


unpackTo(_o: EndGameActionT): void {
  _o.type = this.type();
}
}

export class EndGameActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GameEndGame
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EndGameAction.createEndGameAction(builder,
    this.type
  );
}
}
